@if (chart(); as c) {
  <svg class="sz-range-band" [attr.viewBox]="viewBox" xmlns="http://www.w3.org/2000/svg">
    <g class="sz-range-band__y-labels">
      @for (label of c.yLabels; track label.y) {
        <text [attr.x]="0" [attr.y]="label.y + 4">{{ label.text }}</text>
      }
    </g>
    <g class="sz-range-band__grid">
      @for (label of c.yLabels; track label.y) {
        <line [attr.x1]="padL" [attr.y1]="label.y" [attr.x2]="viewW" [attr.y2]="label.y" />
      }
    </g>
    @if (showBestTrend()) {
      <line
        class="sz-range-band__trend"
        [attr.x1]="c.trendX1"
        [attr.y1]="c.trendY1"
        [attr.x2]="c.trendX2"
        [attr.y2]="c.trendY2" />
    }
    <g class="sz-range-band__bands">
      @for (band of c.bands; track band.label) {
        <line
          [class.is-latest]="band.isLatest"
          class="sz-range-band__band"
          [attr.x1]="band.x"
          [attr.y1]="band.yTop"
          [attr.x2]="band.x"
          [attr.y2]="band.yBottom"
          [attr.stroke-width]="bandWidth"
          stroke-linecap="round" />
        <circle
          [class.is-latest]="band.isLatest"
          class="sz-range-band__avg"
          [attr.cx]="band.x"
          [attr.cy]="band.cy"
          [attr.r]="3" />
      }
    </g>
    <g class="sz-range-band__x-labels">
      @for (band of c.bands; track band.label) {
        <text [attr.x]="band.x" [attr.y]="viewH - 8" text-anchor="middle">{{ band.label }}</text>
      }
    </g>
  </svg>
}
